var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "mobile" },
      [
        _c(
          "v-container",
          { attrs: { "grid-list-md": "" } },
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _vm._l(_vm.foodCategories, function (cat) {
                  return [
                    _c(
                      "v-flex",
                      {
                        key: "F" + cat.id,
                        attrs: { xs12: "", md6: "", lg4: "" },
                      },
                      [
                        _c("CategoryCard", {
                          staticClass: "pointer",
                          attrs: { category: cat },
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.gotoCategory(cat)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                }),
                _vm.showAlternative && _vm.foodCategories.length === 0
                  ? [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("h3", [
                              _vm._v("Das Sortiment ist zur Zeit deaktiviert"),
                            ]),
                            _c("div", [
                              _vm._v(
                                "Versuche es zu einem späteren Zeitpunkt erneut"
                              ),
                            ]),
                            _c("div", { staticClass: "spacer-25" }),
                            _vm.$store.getters.deliveryOrderingEnabled
                              ? _c("MyLieferzeiten")
                              : _vm._e(),
                            _vm.$store.getters.takeawayOrderingEnabled
                              ? _c("MyAbholzeiten")
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "tablet" },
      [
        _c(
          "v-container",
          { attrs: { "grid-list-lg": "" } },
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _vm._l(_vm.foodCategories, function (cat) {
                  return [
                    _c(
                      "v-flex",
                      {
                        key: "F2" + cat.id,
                        attrs: { xs12: "", md6: "", lg4: "" },
                      },
                      [
                        _c("CategoryCard", {
                          staticClass: "pointer",
                          attrs: { category: cat },
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.gotoCategory(cat)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                }),
                _vm.showAlternative && _vm.foodCategories.length === 0
                  ? [
                      _c("v-flex", { attrs: { xs12: "" } }, [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c("h3", [
                              _vm._v("Das Sortiment ist zur Zeit deaktiviert"),
                            ]),
                            _c("div", [
                              _vm._v(
                                "Versuche es zu einem späteren Zeitpunkt erneut"
                              ),
                            ]),
                            _vm.$store.getters.deliveryOrderingEnabled
                              ? _c("MyLieferzeiten")
                              : _vm._e(),
                            _vm.$store.getters.takeawayOrderingEnabled
                              ? _c("MyAbholzeiten")
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }